import { render, staticRenderFns } from "./InstagramVitadioLife.vue?vue&type=template&id=2d20f53a"
import script from "./InstagramVitadioLife.vue?vue&type=script&lang=js"
export * from "./InstagramVitadioLife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports